module.exports = "\n<div>\n  <app-sidebar></app-sidebar>\n  <app-prevchart></app-prevchart>\n  <app-chart></app-chart>\n</div>\n\n\n\n\n"